<template>
  <div class="nmap-log" data-testid="nmap-log">
    <div class="nmap-log__head">
      <span class="nmap-log__title">Nhật ký quét</span>
      <span class="nmap-log__status" :class="`nmap-log__status--${status}`">
        {{ statusLabel }}
      </span>
      <button
        v-if="status !== 'closed'"
        class="nmap-log__close"
        title="Đóng"
        @click="close"
      >
        ✕
      </button>
    </div>
    <pre ref="bodyRef" class="nmap-log__body">{{ text || "Đang chờ agent..." }}</pre>
  </div>
</template>

<script setup lang="ts">
defineOptions({ name: "NmapLogViewer" });

import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { appendLogLine, getLogWsUrl } from "./nmapLogSession";

const props = defineProps<{
  actionId: string;
}>();

const emit = defineEmits<{
  close: [];
}>();

const bodyRef = ref<HTMLElement>();
const text = ref("");
const status = ref<"connecting" | "streaming" | "closed">("connecting");

let ws: WebSocket | null = null;
let unmounted = false;

const statusLabel = computed(() =>
  status.value === "connecting"
    ? "Đang kết nối..."
    : status.value === "streaming"
      ? "Đang nhận"
      : "Đã kết thúc",
);

function scrollToEnd() {
  const el = bodyRef.value;
  if (el) el.scrollTop = el.scrollHeight;
}

function close() {
  ws?.close();
  status.value = "closed";
  emit("close");
}

onMounted(() => {
  ws = new WebSocket(getLogWsUrl(props.actionId));
  ws.onopen = () => {
    if (!unmounted) status.value = "streaming";
  };
  ws.onmessage = (event) => {
    if (unmounted || typeof event.data !== "string") return;
    text.value = appendLogLine(text.value, event.data);
    scrollToEnd();
  };
  ws.onclose = () => {
    if (!unmounted) status.value = "closed";
  };
  ws.onerror = () => {
    if (!unmounted) status.value = "closed";
  };
});

onBeforeUnmount(() => {
  unmounted = true;
  ws?.close();
});
</script>

<style scoped>
.nmap-log {
  display: flex;
  flex-direction: column;
  background: #1e1e1e;
  border-radius: 0;
  overflow: hidden;
  height: 100%;
  min-height: 240px;
}

.nmap-log__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: #252526;
  color: #d4d4d4;
  font-size: 13px;
  border-bottom: 1px solid #333;
}

.nmap-log__title {
  font-weight: 600;
}

.nmap-log__status {
  font-size: 12px;
  padding: 1px 6px;
  border: 1px solid #555;
}

.nmap-log__status--streaming {
  color: #4ec9b0;
  border-color: #4ec9b0;
}

.nmap-log__status--closed {
  color: #888;
}

.nmap-log__close {
  margin-left: auto;
  background: transparent;
  color: #d4d4d4;
  border: none;
  cursor: pointer;
  font-size: 13px;
}

.nmap-log__body {
  flex: 1;
  margin: 0;
  padding: 10px;
  overflow: auto;
  color: #d4d4d4;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
